import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  description?: string;
  inverted?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  inverted = false
}: SectionHeadingProps) {
  return <header className="mx-auto max-w-2xl text-center" data-id="element-26">
      <p className={`inline-flex rounded-full px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] ${inverted ? 'bg-emerald-400/20 text-emerald-200' : 'bg-emerald-100 text-emerald-800'}`} data-id="element-27">
        {eyebrow}
      </p>
      <h2 className={`mt-3 text-3xl font-black leading-[1.05] tracking-tight sm:text-4xl ${inverted ? 'text-white' : 'text-emerald-950'}`} data-id="element-28">
        {title}
      </h2>
      {description && <p className={`mt-4 text-sm leading-6 ${inverted ? 'text-emerald-100/75' : 'text-slate-600'}`} data-id="element-29">
          {description}
        </p>}
    </header>;
}